import { TOKEN_KEY, USER_KEY } from "./const";

const SIGN_IN_PATH = "/login";
const PUBLIC_PATHS = ["/", "/auth", "/login", "/login/phone", "/signup", "/verify", "/forgot-password"];

/** True when the token's expiry time (JWT "exp") has passed or it can't be read */
export const isTokenExpired = (token: string | null): boolean => {
  if (!token) return true;
  try {
    const payload = JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
    return typeof payload.exp === "number" && payload.exp * 1000 <= Date.now();
  } catch {
    return true;
  }
};

export const clearSession = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};

let redirecting = false;

/**
 * The server no longer accepts the saved login (expired, or the server was
 * updated): forget it and send the customer to sign in again, once.
 */
export const handleSessionExpired = () => {
  if (redirecting) return;
  const hadSession = Boolean(localStorage.getItem(TOKEN_KEY));
  clearSession();
  if (!hadSession || PUBLIC_PATHS.includes(window.location.pathname)) return;
  redirecting = true;
  window.location.assign(`${SIGN_IN_PATH}?expired=1`);
};
